import {Routes} from '@angular/router';
import {RequestDestinationsComponent} from "./request-destinations/request-destinations.component";

export const ReportRoutes: Routes = [
  {
    path: 'admin/report/request/destinations', component: RequestDestinationsComponent
  }

];
